export class IntercomUtils {
    static async hide() {
        // How to hide - https://stackoverflow.com/a/59025458
        window.Intercom("update", {
            hide_default_launcher: true,
        });
    }

    static async show() {
        window.Intercom("update", {
            hide_default_launcher: false,
        });
    }
}
